import { toURLSearchParams } from '@wix/metro-runtime';
import { serializer } from '@wix/metro-runtime/ambassador';
import { resolveUrl } from '@wix/metro-runtime';
var _addConnectionRequest = {};
var _addConnectionResponse = {};
var _approveIdentityRequest = {};
var _approveIdentityResponse = { identity: '_identity' };
var _blockIdentityRequest = {};
var _blockIdentityResponse = { identity: '_identity' };
var _bulkDeleteIdentityRequest = {};
var _bulkDeleteIdentityResponse = {};
var _customField = { value: '_customValue' };
var _customValue = {
    numValue: 'DOUBLE',
    dateValue: 'google.protobuf.Timestamp',
    listValue: '_listValue',
    mapValue: '_mapValue',
};
var _deleteIdentityRequest = {};
var _deleteIdentityResponse = {};
var _hardDeleteIdentityRequest = {};
var _hardDeleteIdentityResponse = {};
var _identity = {
    createdDate: 'google.protobuf.Timestamp',
    updatedDate: 'google.protobuf.Timestamp',
    identityProfile: '_identityProfile',
};
var _identityProfile = { customFields: '_customField' };
var _listValue = { value: '_customValue' };
var _mapValue = { value: 'Map#_customValue' };
var _requireConnectionReEnrollmentRequest = {};
var _requireConnectionReEnrollmentResponse = {};
var _updateIdentityRequest = {
    fieldMask: 'google.protobuf.FieldMask',
    identity: '_identity',
};
var _updateIdentityResponse = { identity: '_identity' };
function resolveWixIamIdentityV1IdentityServiceUrl(opts) {
    var domainToMappings = {
        'manage._base_domain_': [
            {
                srcPath: '/_api/identity-service',
                destPath: '',
            },
        ],
        _: [
            {
                srcPath: '/_api/iam/identity',
                destPath: '',
            },
        ],
        'www.wixapis.com': [
            {
                srcPath: '/iam/identity/v1/identity',
                destPath: '/v1/identity',
            },
        ],
        '*.dev.wix-code.com': [
            {
                srcPath: '/iam/identity/v1/identity',
                destPath: '/v1/identity',
            },
        ],
    };
    return resolveUrl(Object.assign(opts, { domainToMappings: domainToMappings }));
}
/** Update an identity */
export function updateIdentity(payload) {
    var _a = serializer(_updateIdentityRequest, {
        _customField: _customField,
        _customValue: _customValue,
        _identity: _identity,
        _identityProfile: _identityProfile,
        _listValue: _listValue,
        _mapValue: _mapValue,
    }), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_updateIdentityResponse, {
        _customField: _customField,
        _customValue: _customValue,
        _identity: _identity,
        _identityProfile: _identityProfile,
        _listValue: _listValue,
        _mapValue: _mapValue,
    }).fromJSON;
    function __updateIdentity(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.iam.identity.v1.identity',
            method: 'PATCH',
            methodFqn: 'wix.iam.identity.v1.IdentityService.UpdateIdentity',
            url: resolveWixIamIdentityV1IdentityServiceUrl({
                protoPath: '/v1/identities/{identity.id}',
                data: serializedData,
                host: host,
            }),
            data: serializedData,
            transformResponse: fromRes,
        };
        return metadata;
    }
    __updateIdentity.fromReq = fromReq;
    __updateIdentity.__isAmbassador = true;
    return __updateIdentity;
}
/**
 * removes the PENDING_ADMIN_APPROVAL_REQUIRED status reason
 * sets the status to active (if no other pending reasons exists)
 */
export function approveIdentity(payload) {
    var _a = serializer(_approveIdentityRequest, {}), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_approveIdentityResponse, {
        _customField: _customField,
        _customValue: _customValue,
        _identity: _identity,
        _identityProfile: _identityProfile,
        _listValue: _listValue,
        _mapValue: _mapValue,
    }).fromJSON;
    function __approveIdentity(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.iam.identity.v1.identity',
            method: 'PATCH',
            methodFqn: 'wix.iam.identity.v1.IdentityService.ApproveIdentity',
            url: resolveWixIamIdentityV1IdentityServiceUrl({
                protoPath: '/management/v1/{identityId}/approve',
                data: serializedData,
                host: host,
            }),
            data: serializedData,
            transformResponse: fromRes,
        };
        return metadata;
    }
    __approveIdentity.fromReq = fromReq;
    __approveIdentity.__isAmbassador = true;
    return __approveIdentity;
}
/** change the identity status to block */
export function blockIdentity(payload) {
    var _a = serializer(_blockIdentityRequest, {}), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_blockIdentityResponse, {
        _customField: _customField,
        _customValue: _customValue,
        _identity: _identity,
        _identityProfile: _identityProfile,
        _listValue: _listValue,
        _mapValue: _mapValue,
    }).fromJSON;
    function __blockIdentity(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.iam.identity.v1.identity',
            method: 'PATCH',
            methodFqn: 'wix.iam.identity.v1.IdentityService.BlockIdentity',
            url: resolveWixIamIdentityV1IdentityServiceUrl({
                protoPath: '/management/v1/{identityId}/block',
                data: serializedData,
                host: host,
            }),
            data: serializedData,
            transformResponse: fromRes,
        };
        return metadata;
    }
    __blockIdentity.fromReq = fromReq;
    __blockIdentity.__isAmbassador = true;
    return __blockIdentity;
}
/** delete identity */
export function deleteIdentity(payload) {
    var _a = serializer(_deleteIdentityRequest, {}), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_deleteIdentityResponse, {}).fromJSON;
    function __deleteIdentity(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.iam.identity.v1.identity',
            method: 'PATCH',
            methodFqn: 'wix.iam.identity.v1.IdentityService.DeleteIdentity',
            url: resolveWixIamIdentityV1IdentityServiceUrl({
                protoPath: '/management/v1/{identityId}/delete',
                data: serializedData,
                host: host,
            }),
            data: serializedData,
            transformResponse: fromRes,
        };
        return metadata;
    }
    __deleteIdentity.fromReq = fromReq;
    __deleteIdentity.__isAmbassador = true;
    return __deleteIdentity;
}
/** bulk delete identities */
export function bulkDeleteIdentity(payload) {
    var _a = serializer(_bulkDeleteIdentityRequest, {}), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_bulkDeleteIdentityResponse, {}).fromJSON;
    function __bulkDeleteIdentity(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.iam.identity.v1.identity',
            method: 'DELETE',
            methodFqn: 'wix.iam.identity.v1.IdentityService.BulkDeleteIdentity',
            url: resolveWixIamIdentityV1IdentityServiceUrl({
                protoPath: '/management/v1/bulk',
                data: serializedData,
                host: host,
            }),
            params: toURLSearchParams(serializedData),
            transformResponse: fromRes,
        };
        return metadata;
    }
    __bulkDeleteIdentity.fromReq = fromReq;
    __bulkDeleteIdentity.__isAmbassador = true;
    return __bulkDeleteIdentity;
}
/** delete identity */
export function hardDeleteIdentity(payload) {
    var _a = serializer(_hardDeleteIdentityRequest, {}), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_hardDeleteIdentityResponse, {}).fromJSON;
    function __hardDeleteIdentity(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.iam.identity.v1.identity',
            method: 'DELETE',
            methodFqn: 'wix.iam.identity.v1.IdentityService.HardDeleteIdentity',
            url: resolveWixIamIdentityV1IdentityServiceUrl({
                protoPath: '/management/v1/{identityId}/hard_delete',
                data: serializedData,
                host: host,
            }),
            params: toURLSearchParams(serializedData),
            transformResponse: fromRes,
        };
        return metadata;
    }
    __hardDeleteIdentity.fromReq = fromReq;
    __hardDeleteIdentity.__isAmbassador = true;
    return __hardDeleteIdentity;
}
/** sets the identity's connection re-enrolled boolean associated with  connectionId, */
export function requireConnectionReEnrollment(payload) {
    var _a = serializer(_requireConnectionReEnrollmentRequest, {}), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_requireConnectionReEnrollmentResponse, {}).fromJSON;
    function __requireConnectionReEnrollment(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.iam.identity.v1.identity',
            method: 'PATCH',
            methodFqn: 'wix.iam.identity.v1.IdentityService.RequireConnectionReEnrollment',
            url: resolveWixIamIdentityV1IdentityServiceUrl({
                protoPath: '/management/v1/{identityId}/connections/{connectionId}/re-enroll',
                data: serializedData,
                host: host,
            }),
            data: serializedData,
            transformResponse: fromRes,
        };
        return metadata;
    }
    __requireConnectionReEnrollment.fromReq = fromReq;
    __requireConnectionReEnrollment.__isAmbassador = true;
    return __requireConnectionReEnrollment;
}
export function addConnection(payload) {
    var _a = serializer(_addConnectionRequest, {}), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_addConnectionResponse, {}).fromJSON;
    function __addConnection(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.iam.identity.v1.identity',
            method: 'POST',
            methodFqn: 'wix.iam.identity.v1.IdentityService.AddConnection',
            url: resolveWixIamIdentityV1IdentityServiceUrl({
                protoPath: '/v1/identity/{id}',
                data: serializedData,
                host: host,
            }),
            data: serializedData,
            transformResponse: fromRes,
        };
        return metadata;
    }
    __addConnection.fromReq = fromReq;
    __addConnection.__isAmbassador = true;
    return __addConnection;
}
//# sourceMappingURL=http.impl.js.map